/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

import { Delete, Edit } from "@mui/icons-material";
import {
  Avatar,
  Box,
  ButtonGroup,
  Chip,
  IconButton,
  Pagination,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import {
  openDeleteUserModal,
  openEditUserModal,
} from "../../Store/Slices/userSlice";
import { PaginationDetails } from "../../Utils/Utils";
import { useEffect } from "react";
import { useState } from "react";

import styles from "./UserList.module.css";

const UserList = ({ data }) => {
  const dispatch = useDispatch();
  
  const [roles, setRoles] = useState("")

  useEffect(() => {
    const getRoles = () => {
      if (typeof window !== undefined) {
        setRoles(sessionStorage.getItem("role"));
      }
    }
    getRoles()
  }, [])

  const dataSet = Array.isArray(data.data) ? data.data : [];

  const { page, count, handleChange, _DATA } = PaginationDetails(dataSet);

  return (
    <>
      <div className={styles.container}>
        {_DATA.currentData()?.map((user) => (
          <div key={user.userId} className={styles.row}>
            <div className={styles.subContainer}>
              <Avatar
                className={styles.image}
                alt={user.userName}
                src={`${process.env.REACT_APP_IMAGE_URL}${user.userProPic}`}
              />
              <div className={styles.textContainer}>
                <Typography className={styles.text1}>
                  {user.userName}
                </Typography>
                <Typography className={styles.text2}>
                  {user.userEmail}
                </Typography>
              </div>
              <div className={styles.brContainer}>
                {user.userBR.map((br) => (
                  <Chip key={br.brId} label={br.brName} />
                ))}
              </div>
            </div>

            <div className={styles.buttonContainer}>
              <ButtonGroup variant="text" aria-label="text button group">
                {roles?.split(",").includes("PRIV_ECOM_EDITUSER") && <IconButton
                  onClick={() => {
                    dispatch(openEditUserModal(user.userId));
                  }}
                >
                  <Edit />
                </IconButton>}
                {roles?.split(",").includes("PRIV_ECOM_DELETEUSER") && <IconButton
                  onClick={() => {
                    dispatch(openDeleteUserModal(user.userId));
                  }}
                >
                  <Delete />
                </IconButton>}
              </ButtonGroup>
            </div>
          </div>
        ))}
      </div>
      <Box my={2} display="flex" justifyContent="center">
        <Pagination
          count={count}
          size="large"
          page={page}
          variant="outlined"
          color="primary"
          onChange={handleChange}
          className={styles.pagination}
        />
      </Box>
    </>
  );
};

export default UserList;
